export default "__VITE_ASSET__Dldp8ufb__"